import type { Shift } from "@repo/api";
import type { ColumnDef } from "@tanstack/react-table";
import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { SettingsHeader } from "~/components/layout/settings-header";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { useShift } from "~/hooks/use-shift";

export const Route = createFileRoute(
  "/_main/settings/_layout/bookings/special-days",
)({
  component: SpecialDays,
});

function SpecialDays() {
  const { t } = useTranslation("common");
  const { shifts } = useShift();

  const columns: ColumnDef<Shift>[] = [
    {
      id: t("Shifts.date"),
      accessorKey: "startDate",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("recurrence")} />
      ),
      cell: ({ row: { original: shift }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p>
            {t("Shift.recurrence_never", {
              date: format(shift.startDate, "PPPP"),
            })}
          </p>
        );
      },
    },
  ];
  return (
    <>
      <SettingsHeader title={t("special_days")} />
      <DataTable
        columns={columns}
        data={shifts.filter((shift) => shift.closed === true)}
      />
    </>
  );
}
